import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { BaseFieldDataSourceControl } from '@d-components/base-field-control/base-data-source-control';
import { BaseLabelComponent } from '@d-components/label/label.component';
import { TranslateModule } from '@ngx-translate/core';
import { RadioButtonModule } from 'primeng/radiobutton';

@Component({
  selector: 'app-base-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    RadioButtonModule,
    CommonModule,
    BaseLabelComponent,
    TranslateModule,
  ],
})
export class BaseRadioComponent extends BaseFieldDataSourceControl {
  @Input() options!: { label?: any; value: any; preIcon?: string }[];
  @Input() direction: 'row' | 'column' = 'row';
  @Input() containerClass = '';
  @Input() inputContainerClass = '';
  @Input() labelClass = '';

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
